module.exports = __webpack_public_path__ + "img/id-card.9ae43e13.svg";